import React, { useState } from 'react';

import SideBar from '../components/system/SideBar';
import Header from '../components/system/Header';
import MainContent from '../components/system/MainContent';
import OffMainContent from '../components/system/OffMainContent';
import Users from './system/Users';
import Rooms from './system/Rooms';
import ExpiredBookings from '../components/system/bookings/ExpiredBookings';
import CanceledBookings from '../components/system/bookings/CanceledBookings';
import OffExpiredBookings from '../components/system/offBookings/OffExpiredBookings';
import OffCanceledBookings from '../components/system/offBookings/OffCanceledBookings';
import ReceptionBookings from '../components/system/reception/ReceptionBookings';
import ReceptionConfirmBookings from '../components/system/reception/ReceptionConfirmBookings';
import ReceptionCanceledBookings from '../components/system/reception/ReceptionCanceledBookings';
import NoPaymentBookings from '../components/system/NoPaymentBookings';
import Reviews from '../components/system/Reviews';
import Customers from '../templates/system/Customers';
import OffCheckedinBookings from '../components/system/offBookings/OffCheckedinBookings';
import CheckedinBookings from '../components/system/bookings/CheckedinBookings';
import OffCheckedoutBookings from '../components/system/offBookings/OffCheckedoutBookings';
import CheckedoutBookings from '../components/system/bookings/CheckedoutBookings';
import CanceledBookingsRefunded from '../components/system/bookings/CanceledBookingsRefunded';
import OffCanceledBookingsRefunded from '../components/system/offBookings/OffCanceledBookingsRefunded';
import OnlineSettings from './system/OnlineSettings';
import { AdminLanguageProvider } from '../AdminLanguageContext';

function System({ type }) {

  const [headerTitle, setHeaderTitle] = useState('')

  return (
    <AdminLanguageProvider>
      <div className='system-body'>
        <SideBar />
        <div className="system-main-content">
          <Header title={headerTitle} />
          {type === "reception" && <ReceptionBookings />}
          {type === "receptionConfirmes" && <ReceptionConfirmBookings />}
          {type === "receptionCanceledBookings" && <ReceptionCanceledBookings />}
          {type === "offMain" && <OffMainContent />}
          {type === "offCheckedinBookings" && <OffCheckedinBookings setHeaderTitle={setHeaderTitle} />}
          {type === "offCheckedoutBookings" && <OffCheckedoutBookings setHeaderTitle={setHeaderTitle} />}
          {type === "offExpiredBookings" && <OffExpiredBookings setHeaderTitle={setHeaderTitle} />}
          {type === "offCanceledBookings" && <OffCanceledBookings setHeaderTitle={setHeaderTitle} />}
          {type === "offCanceledBookingsRefunded" && <OffCanceledBookingsRefunded setHeaderTitle={setHeaderTitle} />}
          {type === "nopaybookings" && <NoPaymentBookings />}
          {type === "main" && <MainContent setHeaderTitle={setHeaderTitle} />}
          {type === "checkedinBookings" && <CheckedinBookings setHeaderTitle={setHeaderTitle} />}
          {type === "checkedoutBookings" && <CheckedoutBookings setHeaderTitle={setHeaderTitle} />}
          {type === "expiredBookings" && <ExpiredBookings setHeaderTitle={setHeaderTitle} />}
          {type === "canceledBookings" && <CanceledBookings setHeaderTitle={setHeaderTitle} />}
          {type === "canceledBookingsRefunded" && <CanceledBookingsRefunded setHeaderTitle={setHeaderTitle} />}
          {type === "users" && <Users />}
          {type === "reviews" && <Reviews />}
          {type === "rooms" && <Rooms setHeaderTitle={setHeaderTitle} />}
          {type === "customers" && <Customers setHeaderTitle={setHeaderTitle} />}
          {type === "onlineSettings" && <OnlineSettings setHeaderTitle={setHeaderTitle} />}
        </div>
      </div>
    </AdminLanguageProvider>
  );
}

export default System;
